import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';
import { adalConfig, authContext } from '../../Utils/AdalConfig';

export default class SessionRenewal extends Component {

    state = {
        renewed: false,
        closeFailed: false
    };

    componentDidMount() {
        this._mounted = true;
        // with a valid session (login just completed, or opened by mistake) show the return screen right away;
        // otherwise force the interactive login in this tab — the AAD redirect returns to this route.
        // endpoints.api === clientId in this app, so this reads the exact cache entry adal writes after the
        // redirect (the idtoken doubles as the api access token) — a clientId fallback would be redundant
        const token = authContext.getCachedToken(adalConfig.endpoints.api);
        if (token) {
            this.setState({ renewed: true });
        } else {
            authContext.login();
        }
    }

    componentWillUnmount() {
        this._mounted = false;
        clearTimeout(this._closeTimer);
    }

    closeTab = () => {
        // the browser blocks window.close() after the AAD round-trip (cross-origin history); if it fails this timeout still runs
        window.close();
        this._closeTimer = setTimeout(() => {
            if (this._mounted) {
                this.setState({ closeFailed: true });
            }
        }, 300);
    }

    render() {
        const { renewed, closeFailed } = this.state;

        return (
            <div className="container text-center py-5">
                {renewed ?
                    <div>
                        <i className="fas fa-check-circle text-success mb-3" style={{ fontSize: '34px' }} />
                        <h5 className="mb-3"><FormattedMessage id="SessionRenewal.Success" /></h5>
                        <p><FormattedMessage id="SessionRenewal.ReturnInstruction" /></p>
                        <Button className="btn btn-sm btn-host" onClick={this.closeTab}>
                            <FormattedMessage id="SessionRenewal.CloseTab" />
                        </Button>
                        {closeFailed ?
                            <p className="text-muted mt-3 mb-0"><FormattedMessage id="SessionRenewal.CloseTabFailed" /></p>
                        : ''}
                    </div>
                :
                    <div>
                        <i className="fas fa-circle-notch fa-spin mb-3" style={{ fontSize: '28px' }} />
                        <p><FormattedMessage id="SessionRenewal.Redirecting" /></p>
                    </div>
                }
            </div>
        );
    }
}
